import { workbenchUrl } from "@crm/shared/workbench-link";
import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * 302 保旧链（M3）：class-progress 公开页已外化至 workbench。
 * 微信等渠道分享过的旧链接统一 302 到 workbench 对应路径。
 */
export const Route = createFileRoute("/class-progress/$classSessionId/$groupId/")({
  beforeLoad: ({ params }) => {
    const href = workbenchUrl(`/class-progress/${params.classSessionId}/${params.groupId}`);
    throw redirect({ href });
  },
});
